import { extendTailwindMerge } from 'tailwind-merge';

export const sonaTwMerge = extendTailwindMerge({
    prefix: 'tw-'
});
